import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { CommonService } from 'src/app/shared/common.service';
import { catchError, finalize, map, of, switchMap, tap } from 'rxjs';
import { APIResponse } from 'src/app/core/models/api-response';
import { SetLoading } from 'src/app/shared/store/shared.actions';
import { AlertEnums } from 'src/app/shared/enums/shared.enums';
import * as WishlistsActions from './wishlist.actions';
import { WishlistService } from '../services/wishlist.services';
import { FetchAllCatalogs } from '../../catalogs/store/catalogs.actions';
import { ICatalog } from '../../catalogs/models/catalogs.models';

@Injectable()
export class WishlistsEffects {
  constructor(
    private actions$: Actions,
    public store: Store<AppState>,
    private wishlistsServices: WishlistService,
    private commonService: CommonService
  ) {}

  // fetch All Wishlists
  FetchAllWishlistsEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(WishlistsActions.FetchAllWishlist),
      switchMap(() =>
        this.wishlistsServices.listAllWishlist().pipe(
          map((res: APIResponse<ICatalog>) =>
            WishlistsActions.FetchAllWishlistSuccess({ wishlist: res })
          ),
          tap(() => {
            this.store.dispatch(SetLoading({ isAppLoading: false }));
          }),
          catchError(() =>
            of(WishlistsActions.FetchAllWishlistError()).pipe(
              tap(() => {
                this.store.dispatch(SetLoading({ isAppLoading: false }));
              })
            )
          )
        )
      ),
      finalize(() => {
        this.store.dispatch(SetLoading({ isAppLoading: false }));
      })
    )
  );

  // add To Wishlist
  ToggleWishlistEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(WishlistsActions.ToggleWishlist),
      switchMap((action) =>
        this.wishlistsServices.ToggleWishlist(action.id).pipe(
          map((res: APIResponse<ICatalog>) =>
            WishlistsActions.ToggleWishlistSuccess({ wichlist: res.data[0] })
          ),
          tap(() => {
            this.store.dispatch(WishlistsActions.FetchAllWishlist());
            this.store.dispatch(FetchAllCatalogs());
          }),
          catchError(() =>
            of(WishlistsActions.ToggleWishlistError()).pipe(
              tap(() => {
                this.store.dispatch(SetLoading({ isAppLoading: false }));
                this.commonService.showToast(AlertEnums.EditError, 'ERROR');
              })
            )
          )
        )
      ),
      finalize(() => {
        this.store.dispatch(SetLoading({ isAppLoading: false }));
      })
    )
  );
}
